// RescheduleCampaignModal is used for Drag and drop
import React, { Dispatch, SetStateAction, useState } from 'react'
import { Form } from 'react-bootstrap'
import { Button, ConfirmationModal } from '@components/common'
import './RescheduleCampaignStyle.css'
import { format } from 'date-fns'
import { ICampaignRequest } from '@dataTypes/marketing.type'
import { UPLOAD_TIME_OPTIONS } from '@constants/Marketing'

type RescheduleCampaignProps = {
  show: boolean
  onHide: () => void
  campaign: ICampaignRequest
  onConfirm: () => void
  setTime: Dispatch<SetStateAction<string>>
  time: string
}

const RescheduleCampaignModal: React.FC<RescheduleCampaignProps> = ({
  show,
  onHide,
  campaign,
  onConfirm,
  setTime,
  time,
}) => {
  const [changeTime, setChangeTime] = useState<boolean>(false)

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    setTime(e.target.value)
  }

  const dateLabel =
    campaign.start_date && format(new Date(campaign.start_date), 'MM/dd/yyyy')

  return (
    <ConfirmationModal
      show={show}
      onHide={onHide}
      title="Reschedule campaign"
      className="confirmation-modal--alert reschedule-campaign-modal"
      headerClassName="confirmation-modal__header"
      size="md"
      body={
        <div className="confirmation-modal__body reschedule-campaign-modal__body">
          <p className="confirmation-modal__title">Reschedule this campaign?</p>
          <p className="confirmation-modal__message">
            Are you sure you want to reschedule &quot;{campaign.name}&quot; to{' '}
            {dateLabel}?
          </p>
          <div className="rcm-checkbox">
            <input
              type="checkbox"
              checked={changeTime}
              onChange={() => setChangeTime(!changeTime)}
            />
            <span className="rcm-sub-text">Change time</span>
          </div>
          {changeTime && (
            <div className="rcm-time-input">
              <span className="time-input-label">Time</span>
              <Form.Select name="time" value={time} onChange={handleChange}>
                {UPLOAD_TIME_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </div>
          )}
        </div>
      }
      footer={
        <div className="confirmation-modal__footer">
          <Button className="button-secondary" size="md" onClick={onHide}>
            Cancel
          </Button>
          <Button size="md" onClick={onConfirm} className="button-primary">
            Confirm
          </Button>
        </div>
      }
    />
  )
}

export default RescheduleCampaignModal
